import { render, staticRenderFns } from "./NewsDetailListItem.vue?vue&type=template&id=aeac71f8"
import script from "./NewsDetailListItem.vue?vue&type=script&lang=js"
export * from "./NewsDetailListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports